import { INTERNALFlag, useINTERNALFlag, PropsNoName } from '@components/Flag';
/** Visibility to 'Admin' in the top nav bar. Users must have this = true for visibility to any options in the Admin list */
export const useFlagnavAdmin = (): boolean => useINTERNALFlag('nav-admin');
/** Visibility to 'Admin' in the top nav bar. Users must have this = true for visibility to any options in the Admin list */
export const FlagnavAdmin = (props: PropsNoName) => <INTERNALFlag name="nav-admin" {...props}/>
